import type { ReactElementWithPayloadProp, SortType } from 'cpool-components/general/DataTable';
import { SORT_TYPES } from 'cpool-components/general/DataTable';
import type { LOAN_REQUEST_OFFER_STATUS_TYPES } from 'cpool-constants';
import { LOAN_REQUEST_OFFER_STATUS } from 'cpool-constants';

const statusOrder = [
    LOAN_REQUEST_OFFER_STATUS.AT_BANK_INCOMPLETE,
    LOAN_REQUEST_OFFER_STATUS.COMMISSION_RECEIVED,
    LOAN_REQUEST_OFFER_STATUS.PAID_OUT,
    LOAN_REQUEST_OFFER_STATUS.APPROVED,
    LOAN_REQUEST_OFFER_STATUS.REJECTED,
    LOAN_REQUEST_OFFER_STATUS.AT_BANK,
    LOAN_REQUEST_OFFER_STATUS.OFFER_PENDING,
    LOAN_REQUEST_OFFER_STATUS.REVOCATION,
    LOAN_REQUEST_OFFER_STATUS.OFFER_CREATED,
    LOAN_REQUEST_OFFER_STATUS.OFFER_EXPIRED,
    LOAN_REQUEST_OFFER_STATUS.CANCELLED,
    LOAN_REQUEST_OFFER_STATUS.OFFER_COULD_NOT_BE_CREATED,
] as const;

export const sortStatus = (
    rows: ReactElementWithPayloadProp<'status', LOAN_REQUEST_OFFER_STATUS_TYPES>[],
    type: SortType,
) => {
    if (type === SORT_TYPES.NO_SORTING) return rows;
    return rows.sort(
        (
            {
                props: {
                    payload: { status: aStatus },
                },
            },
            {
                props: {
                    payload: { status: bStatus },
                },
            },
        ) => {
            const aIndex = statusOrder.indexOf(aStatus);
            const bIndex = statusOrder.indexOf(bStatus);

            if (aIndex === -1 || bIndex === -1) return 0;

            if (type === SORT_TYPES.ASC) {
                return bIndex - aIndex;
            }
            if (type === SORT_TYPES.DESC) {
                return aIndex - bIndex;
            }

            return bStatus.localeCompare(aStatus);
        },
    );
};
